import { UpdatedResultDto } from './updated-result-dto';

export class AllowActionResultDto extends UpdatedResultDto {
    allowLimitedEdit: boolean;
    allowEdit: boolean;
    allowDelete: boolean;
    allowReverse: boolean;
    allowEditGLAccount: boolean;
}
